/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS15 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_14;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_15;
    },
    getDownloadName() {
      return ns.IOS15.nice_name;
    },
  });

  Object.assign(IOS15, {
    slug: `ios_15`,
    nice_name: `iOS 15 adoption`,
    description: `How quickly are consumers upgrading to iOS 15?`,
  });
  ns.IOS15 = IOS15;
});

}.call(window));